// assets
import { CalendarOutlined, GiftOutlined, MedicineBoxOutlined, UserOutlined } from '@ant-design/icons';

// icons
const icons = {
  GiftOutlined,
  CalendarOutlined,
  MedicineBoxOutlined,
  UserOutlined
};

// ==============================|| MENU ITEMS - INTELLIVITTA ||============================== //

const intellivitta = {
  id: 'intellivitta',
  title: 'IntelliVitta',
  type: 'group',
  children: [
    {
      id: 'agendamentos-disparos',
      title: 'Agendamentos',
      type: 'item',
      url: '/intellivitta/agendamentos',
      icon: icons.CalendarOutlined
    },
    {
      id: 'aniversariantes',
      title: 'Aniversariantes',
      type: 'item',
      url: '/cadastros/aniversariantes',
      icon: icons.GiftOutlined
    },
    {
      id: 'pos-atendimento',
      title: 'Pós-atendimento',
      type: 'item',
      url: '/intellivitta/pos-atendimento',
      icon: icons.MedicineBoxOutlined
    }
  ]
};

export default intellivitta;
